import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enAU from './en/AU.json'
import enNZ from './en/NZ.json'
import enUS from './en/US.json'

export const defaultLang = 'en-US' as const

export const defaultNs = 'translation'

export const namespaces = ['translation', 'spelling'] as const

export const resources = {
  'en-AU': enAU,
  'en-NZ': enNZ,
  'en-US': enUS,
} as const

const config = {
  // debug: true,
  fallbackLng: defaultLang,
  ns: namespaces,
  resources,
  detection: {
    caches: [] as string[],
  },
}

const initClient = () =>
  i18n.use(initReactI18next).init({
    ...config,
  })

const initServer = () =>
  i18n.use(initReactI18next).init({
    ...config,
    react: {
      useSuspense: false,
    },
  })

export { initClient, initServer }
